import { useCallback, useState } from 'react';

export function useTransfer() {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const onSelectChange = useCallback(
    (sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
      setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    },
    [setSelectedKeys]
  );

  return {
    selectedKeys,
    onSelectChange,
  };
}
